import { Input } from "@mobiscroll/react5";
import { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import doctor from "src/assets/Doctors 05.svg";
import line from "src/assets/Lines.svg";
import next_icon from "src/assets/Next icon.svg";
// import resend_icon from "src/assets/Resend icon.svg";
import grid from "src/assets/grid.svg";
import signin_circle from "src/assets/signin-circle.svg";
import Loader from "src/components/Dashboard/common/Loader";
import "../Dashboard/Layouts/Card.css";
import "./Auth.scss";
import ResetPassword from "./ResetPassword";
import { resetPassword } from "@aws-amplify/auth";

function ForgotPassword() {
  const [formErrors, setFormErrors] = useState();
  const [step, setStep] = useState(1);
  const [username, setUsername] = useState("");
  const [loader, setLoader] = useState(false);

  const sendOTP = async (username) => {
    console.log("Sending OTP to", username);

    setLoader(true);
    try {
      const data = await resetPassword({username});
      console.log("Reset password initiated successfully", data);
      setStep(2);
    } catch (err) {
      console.error(err);
      setFormErrors(err.message || "An error occurred.");
    } finally {
      setLoader(false);
    }
  }

  const nextStep = async () => {
    await sendOTP(username);
    // if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(username)) {
    // } else {
    //   setFormErrors("Enter Valid username");
    // }
  };

  if (step === 2) return <ResetPassword username={username} />;

  return (
    <Fragment>
      <Helmet>
        <title>Forgot Password | DOCG</title>
      </Helmet>
      <Loader show={loader} />

      <div className="mbsc-grid">
        <div className="mbsc-card main-card-wrapper">
          <div className="signup-wrapper">
            <div className="mbsc-row">
              <div className="mbsc-col-xl-6 doctor-images-left mbsc-col-12">
                <div className="left-signup-div" id="reset-password-page"></div>
                <img src={doctor} className="left-signup-img left-steps-img" alt="Doctor illustration" />
              </div>
              <div className="mbsc-col-xl-6 mbsc-col-12 signup-right">
                <img src={grid} className="grid-top" alt="" />
                <img src={signin_circle} className="signin-circle" alt="" />
                <div className="bottom-circle" />
                <div className="top-circle" />
                <div className="right-signup-div">
                  <div className="get-started-wrapper">
                    <p className="signup-link">Step 1/2</p>
                    <p className="signup-link mt-2">Enter Username (Email) to Change Password.</p>
                    <br />
                    <div className="signup-wrapper-inner">
                      <div className="row">
                        <div className="col-12">
                          <Input
                            labelStyle="floating"
                            inputStyle="underline"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                          <br />

                          {formErrors ? (<span className="otp-error">{formErrors}</span>) : ("")}
                        </div>
                      </div>
                      <br />
                      <button className="purple-button" onClick={nextStep}>
                        <img src={next_icon} alt="" />&nbsp;&nbsp; Continue
                      </button>

                    </div>
                  </div>
                </div>

                <img src={line} style={{ marginLeft: "8%" }} className="lines-bottom" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ForgotPassword;
